import React, { useState, useEffect, useCallback } from 'react';
import { Form, Input, Button, Select, Dropdown, Menu, Radio, message } from 'antd';
import IntlMessages from '@iso/components/utility/intlMessages';
import PropertyModalWrapper from './PropertyModal.styles';
import SimpleTable from '@iso/components/Tables/SimpleTable';
import { configs } from '@iso/components/Tables/configs';
import fakeData from '@iso/components/Tables/data';
import { CheckCircleFilled, ExclamationCircleFilled, SendOutlined, DownOutlined, CopyOutlined } from '@ant-design/icons';
import { propertyService, userService, permissionService } from '@iso/services';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Loader from '@iso/components/utility/loader';
import Table from '@iso/components/collapsing-table/table';
import Box from '@iso/components/utility/box';
import Tabs, { TabPane } from '@iso/components/uielements/tabs';

const { Option } = Select;
const DEFAULT_SETTINGS_VALUES = {
  approvalMode: 'manual',
  automaticApprovalMode: 'allEmails',
  domains: '',
  emails: '',
};

const UserAccessModal = (props) => {
 
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [contractorList, setContractorList] = useState([]);
  const [activeTab, setActiveTab] = useState('members');
  const [form] = Form.useForm();
  const [settingsForm] = Form.useForm();
  const permissions = useSelector(state => state.permission.permissions);
  const [showForm, setShowForm] = useState(false);
  const [fields, setFields] = useState([]);
  const propertyId = props.propertyId ? props.propertyId : activePropertyId;
  const [settingsFetching, setSettingsFetching] = useState(false);
  const [settingsSubmitting, setSettingsSubmitting] = useState(false);
  const approvalMode = Form.useWatch('approvalMode', settingsForm);
  const automaticApprovalMode = Form.useWatch('automaticApprovalMode', settingsForm);

  const updateDataTable = useCallback(() => {
    if (!propertyId) {
      setUsers([]);
      setDataList([]);
      setContractorList([]);
      setModalLoading(false);
      return Promise.resolve();
    }

    return propertyService.getListUsersOfProperty(propertyId, true).then(res => {
      if (res.code === '0000' && Array.isArray(res.users)) {
        const members = res.users.filter(user => user.permission_slug !== 'contractor');
        const contractors = res.users.filter(user => user.permission_slug === 'contractor');
        setUsers(members);
        setDataList(members);
        setContractorList(contractors);
      }
    }).finally(() => {
      setModalLoading(false);
    });
  }, [propertyId]);

  const fetchPropertySettings = useCallback(() => {
    if (!propertyId) {
      settingsForm.setFieldsValue(DEFAULT_SETTINGS_VALUES);
      return;
    }

    setSettingsFetching(true);
    propertyService.getPropertySetting(propertyId).then(res => {
      if (res.code === '0000' && res.property_setting) {
        const setting = res.property_setting;
        const domains = Array.isArray(setting.domains)
          ? setting.domains.map(item => (typeof item === 'string' ? item : item.domain)).filter(Boolean)
          : [];
        const emails = Array.isArray(setting.emails)
          ? setting.emails.map(item => (typeof item === 'string' ? item : item.email)).filter(Boolean)
          : [];
        const autoEnabled = !!setting.enable_auto_contractor_approval;
        let autoModeValue = 'allEmails';
        if (autoEnabled) {
          if (setting.enable_listed_domains) {
            autoModeValue = 'listedDomains';
          } else if (setting.enable_listed_emails) {
            autoModeValue = 'listedEmails';
          }
        }
        const approvalModeValue = autoEnabled
          ? 'auto'
          : (setting.reject_contractor_requests ? 'reject' : 'manual');
        settingsForm.setFieldsValue({
          ...DEFAULT_SETTINGS_VALUES,
          approvalMode: approvalModeValue,
          automaticApprovalMode: autoModeValue,
          domains: domains.join('\n'),
          emails: emails.join('\n'),
        });
      } else {
        settingsForm.setFieldsValue(DEFAULT_SETTINGS_VALUES);
      }
    }).finally(() => {
      setSettingsFetching(false);
    });
  }, [propertyId, settingsForm]);

  useEffect(() => {
    if (propertyId){
      updateDataTable();
      fetchPropertySettings();
      permissionService.getUserPermission(propertyId).then(res => {
        if(res.code === '0000'){
          setShowForm(res.permission === "owner" || res.permission === "admin");
        }
      });
    }
  }, [propertyId, updateDataTable, fetchPropertySettings]);

  useEffect(() => {
    setFields([
      {
        name: "user_name",
        value: props.viewSummary?props.viewSummary.name:'',
      },
      {
        name: "user_email",
        value: props.viewSummary? props.viewSummary.email :'',
      },
      // {
      //   name: "permission",
      //   value: props.editProperty.state,
      // },
      
    ]);

    
  }, [props, props.viewSummary]);

  useEffect(() => {
    settingsForm.setFieldsValue(DEFAULT_SETTINGS_VALUES);
  }, [settingsForm]);

  useEffect(() => {
    if (props.visibleUsermodal || props.visible || props.visibleModal) {
      setActiveTab('members');
      fetchPropertySettings();
    }
  }, [props.visibleUsermodal, props.visible, props.visibleModal, fetchPropertySettings]);
  const cancelModal = () => {
    if (props.cancelModal) {
      props.cancelModal();
    }
  
    form.resetFields();
    setLoading(false);
    if (props.visibleModal) {
      props.setvisibleModal(false)
    }
  }

  const handleOptionClick = (value, object) => {
    object.permission_id = value;
    let usersTmp = _.clone(users);
    let contractorsTmp = _.clone(contractorList);

    const userIndex = _.findIndex(usersTmp, (user) => {
      return user.id === object.id
    });

    if (userIndex !== -1) {
      usersTmp[userIndex] = object;
    }

    const contractorIndex = _.findIndex(contractorsTmp, (user) => {
      return user.id === object.id
    });

    if (contractorIndex !== -1) {
      contractorsTmp[contractorIndex] = object;
    }

    //Owner change
    if(object.permission_id == 1){
      _.forEach(usersTmp,(user) =>{
        if(object.id != user.id && user.permission_id==1){
          user.permission_id = 2;
        }
      });
    }

    setUsers(usersTmp);
    setDataList(usersTmp);
    setContractorList(contractorsTmp);
    permissionService.update({
      id: object.user_property_id,
      permission_id: object.permission_id
    });    
  }

  const resendInvitation = (user) => {
    onStore({
      permission: user.permission_slug,
      user_email: user.email,
      user_name: user.name,
      is_resend: true
    })
  }
  
  const menu = (object) => (
    <div>
      <Menu>
        <Menu.Item key="resend" icon={<SendOutlined />} onClick={(e)=>{resendInvitation(object)}}>
          <IntlMessages id="propertyPage.managePage.resendInvitation" />
        </Menu.Item>
        <Menu.Item key="copyLink" icon={<CopyOutlined />} onClick={(e)=>{navigator.clipboard.writeText(object.invitation_link)}}>
          <IntlMessages id="propertyPage.managePage.copyLink" />
        </Menu.Item>
    </Menu>
    </div>
  );

  const columns = [
    {
      label: <IntlMessages id="antTable.title.user" />,
      accessor: 'name',
      minWidth: 0,
      sortable: false,
      position: 1,
      priorityLevel: 1
    },
    {
      label: <IntlMessages id="antTable.title.email" />,
      accessor: 'email',
      minWidth: 0,
      sortable: false,
      position: 2,
      priorityLevel: 2
    },
    {
      label: <IntlMessages id="antTable.title.status" />,
      accessor: 'status_label',
      minWidth: 0,
      sortable: false,
      position: 3,
      priorityLevel: 3,
    },
    {
      label: 'Manager',
      accessor: 'manager_name',
      minWidth: 150,
      sortable: false,
      position: 4,
      priorityLevel: 4,
      CustomComponent: cell => {
        const object = cell.row;
        const eligibleManagers = getEligibleManagers(object.id);

        // Only show manager selection for accepted users (not pending)
        if (!object.status) {
          return <span style={{ color: '#999' }}>-</span>;
        }

        return (
          <Select
            style={{ width: '100%', minWidth: 120 }}
            placeholder="Select manager"
            value={object.manager_id || undefined}
            allowClear
            onChange={(value) => handleManagerChange(value, object)}
            disabled={!showForm}
            size="small"
          >
            {eligibleManagers.map(manager => (
              <Option key={manager.id} value={manager.id}>
                {manager.name}
              </Option>
            ))}
          </Select>
        );
      }
    },
    {
      label: <IntlMessages id="antTable.title.permission" />,
      accessor: 'permission',
      minWidth: 100,
      sortable: false,
      position: 5,
      priorityLevel: 5,
    },
    {
      label: '',
      accessor: 'action',
      minWidth: 0,
      sortable: false,
      position: 6,
      priorityLevel: 6,
      CustomComponent: cell => {
        let object = cell.row
        return !object.status ?
          <Dropdown overlay={menu(object)} trigger={['click']}>
              <Button className="btn-success ant-btn-primary">
              <span><IntlMessages id="antTable.title.actions" /></span> <DownOutlined />
              </Button>
          </Dropdown> : <></>;
      }
    },
    {
      label: '',
      accessor: 'actions',
      minWidth: 220,
      sortable: false,
      position: 7,
      priorityLevel: 7,
      noTitle: true,
      CustomComponent: cell => {
        let object = cell.row
        const actionButtons = [];

        if (!object.status && object.permission_slug === 'contractor') {
          actionButtons.push(
            <Button
              key="approve"
              type="primary"
              className="btn-success accept-button"
              onClick={() => handleApproveContractor(object)}
            >
              Accept
            </Button>
          );
        }

        if (object.permission_id != 1) {
          actionButtons.push(
            <Button key="submit" onClick={handleCancelInvite.bind(this, object)} className="cancel-button">
              {object.status ? <IntlMessages id="propertyPage.modal.removeUser" /> : <IntlMessages id="propertyPage.modal.cancelInvite" />}
            </Button>
          );
        }

        return actionButtons.length ? (
          <div className="action-buttons">
            {actionButtons}
          </div>
        ) : null;
      },
    },
  ];
   
  const handleCancelInvite = (object) => {
    if (!propertyId) {
      message.error('Property is not selected.');
      return;
    }
    setModalLoading(true);
    propertyService.cancelInviteUser(propertyId, object.id).then(res => {
      if(res.code === '0000'){
        message.success('Invitation updated.');
        return updateDataTable();
      }
      return Promise.reject(new Error(res.message || 'Failed to update invitation.'));
    }).catch((error) => {
      message.error(error.message || 'Failed to update invitation.');
      setModalLoading(false);
    });
  }

  const handleApproveContractor = (object) => {
    if (!propertyId) {
      message.error('Property is not selected.');
      return;
    }
    setModalLoading(true);
    propertyService.approveContractor(propertyId, object.id).then(res => {
      if (res.code === '0000') {
        message.success('Contractor approved.');
        return updateDataTable();
      }
      return Promise.reject(new Error(res.message || 'Failed to approve contractor.'));
    }).catch((error) => {
      message.error(error.message || 'Failed to approve contractor.');
      setModalLoading(false);
    });
  }

  const handleManagerChange = (managerId, object) => {
    // Update locally first for better UX
    let usersTmp = _.clone(users);
    let contractorsTmp = _.clone(contractorList);

    const userIndex = _.findIndex(usersTmp, (user) => user.id === object.id);
    if (userIndex !== -1) {
      usersTmp[userIndex] = {
        ...usersTmp[userIndex],
        manager_id: managerId || null,
        manager_name: managerId ? (users.find(u => u.id === managerId)?.name || null) : null
      };
    }

    const contractorIndex = _.findIndex(contractorsTmp, (user) => user.id === object.id);
    if (contractorIndex !== -1) {
      contractorsTmp[contractorIndex] = {
        ...contractorsTmp[contractorIndex],
        manager_id: managerId || null,
        manager_name: managerId ? (users.find(u => u.id === managerId)?.name || null) : null
      };
    }

    setUsers(usersTmp);
    setDataList(usersTmp);
    setContractorList(contractorsTmp);

    // Call API to persist the change
    propertyService.updateUserManager(object.user_property_id, managerId || null).then(res => {
      if (res.code === '0000') {
        message.success('Manager updated successfully.');
      } else {
        message.error(res.message || 'Failed to update manager.');
        // Refresh data to revert local changes
        updateDataTable();
      }
    }).catch(() => {
      message.error('Failed to update manager.');
      updateDataTable();
    });
  }

  // Get list of eligible managers (accepted users in the property, excluding contractors)
  const getEligibleManagers = (excludeUserId) => {
    return users.filter(user =>
      user.id !== excludeUserId &&
      user.status && // Only accepted users
      user.permission_slug !== 'contractor'
    );
  }

  const renderOptionsPermission = () => {
    let options = [];
    _.forEach(permissions, (permission) => {
      options.push(
        <Option key={permission.id} value={permission.slug}>{permission.name}</Option>
      );
    })
    return (
      <Select
        placeholder="Select a permission"
        allowClear
        size="large"
      >
        {options}
      </Select>
    );
  }

  const handleSubmit = (e) => {
    setLoading(true);

    form
      .validateFields()
      .then(values => {
        setModalLoading(true);
        onStore(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
        setLoading(false);
      });
  }

  const onStore = (values) => {
    propertyService.inviteUser(propertyId, values).then(res => {
      if(res.code === '0000'){
        updateDataTable();
        setFields([]);
        if (props.visibleModal) {
          props.setvisibleModal(false);
        }
        form.resetFields();
        setLoading(false);
      }
    });
  }

  const buildSettingsPayload = (values) => {
    const mode = values.approvalMode || 'manual';
    const autoEnabled = mode === 'auto';
    const autoMode = values.automaticApprovalMode || 'allEmails';
    return {
      enable_auto_contractor_approval: autoEnabled,
      enable_all_emails: autoEnabled && autoMode === 'allEmails',
      enable_listed_domains: autoEnabled && autoMode === 'listedDomains',
      enable_listed_emails: autoEnabled && autoMode === 'listedEmails',
      manual_contractor_approval: mode === 'manual',
      reject_contractor_requests: mode === 'reject',
      domains: autoEnabled && autoMode === 'listedDomains' ? (values.domains || '') : '',
      emails: autoEnabled && autoMode === 'listedEmails' ? (values.emails || '') : '',
    };
  };

  const handleSettingsSubmit = () => {
    if (!propertyId) {
      message.error('Property is not selected.');
      return;
    }

    settingsForm
      .validateFields()
      .then(values => {
        setSettingsSubmitting(true);
        const payload = buildSettingsPayload(values);
        propertyService.updatePropertySetting(propertyId, payload).then(res => {
          if (res.code === '0000') {
            message.success('Contractor settings updated.');
            fetchPropertySettings();
          } else {
            message.error(res.message || 'Failed to update contractor settings.');
          }
        }).catch(() => {
          message.error('Failed to update contractor settings.');
        }).finally(() => {
          setSettingsSubmitting(false);
        });
      })
      .catch(() => {});
  };

  return (
    <PropertyModalWrapper
      className="user-access-modal"
      forceRender={true}
      open= {props.visibleUsermodal ? props.visibleUsermodal :props.visible  || props.visibleModal}
     
      title={props.visibleModal ? 'Invite Visitor To Property' :<IntlMessages id="propertyPage.modal.userAccess" />}
      onCancel={cancelModal}
      footer={[
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button key="submit" className="btn-success" type="primary" loading={loading} onClick={handleSubmit}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <TabPane tab={<IntlMessages id="propertyPage.modal.userAccess" />} key="members">
          <div className="tab-pane-body">
            {!props.visibleModal && (
              modalLoading ? (
                <div className="table-status">
                  <Loader />
                </div>
              ) : (
                dataList.length > 0 ? (
                  <div id="containerBox" className="table-wrapper">
                    <Table
                      columns={columns}
                      rows={dataList}
                      containerId="containerBox"
                      showPagination={false}
                      rowSize={99999}
                    />
                  </div>
                ) : (
                  <Box className="empty-state">
                    No users found.
                  </Box>
                )
              )
            )}
            <Form
              form={form}
              fields={fields}
              name="inviteUser"
              layout="vertical"
              scrollToFirstError
            >
              {
                showForm &&
                <div>
                  <div className="form-title">
                    <h3>Invite User Form</h3>
                  </div>
                  <div className="form-body">
                    <Form.Item
                      name="user_name"
                      label="User Name"
                      rules={[
                        {
                          required: true,
                          message: 'This field is required',
                        },
                      ]}
                    >
                    <Input size="large" placeholder="Input user name"/>
                    </Form.Item>
                    <Form.Item
                      name="user_email"
                      className="isoInputWrapper"
                      label="User Email"
                      rules={[
                        {
                          required: true,
                          message: 'This field is required',
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid Email',
                        },
                        () => ({
                          validator(rule, value) {
                            if(value)
                              return userService.checkEmailExistsInProperty(value, propertyId);
                            else
                              return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <Input className="pac-target-input" size="large" placeholder="Input user email"/>
                    </Form.Item>
                    <Form.Item
                      name="permission"
                      label="Permission"
                      rules={[
                        {
                          required: true,
                          message: 'This field is required',
                        },
                      ]}
                    >
                      {renderOptionsPermission()}
                    </Form.Item>
                  </div>
                </div>
              }
            </Form>
          </div>
        </TabPane>
        <TabPane tab="Contractor User" key="contractors">
          <div className="tab-pane-body">
            {modalLoading ? (
              <div className="table-status">
                <Loader />
              </div>
            ) : contractorList.length > 0 ? (
              <div id="contractorContainer" className="table-wrapper">
                <Table
                  columns={columns}
                  rows={contractorList}
                  containerId="contractorContainer"
                  showPagination={false}
                  rowSize={99999}
                />
              </div>
            ) : (
              <Box className="empty-state">
                No contractor users found.
              </Box>
            )}
          </div>
        </TabPane>
        <TabPane tab="Settings" key="settings">
          <div className="tab-pane-body">
            {settingsFetching ? (
              <div className="table-status">
                <Loader />
              </div>
            ) : (
              <>
                <Form
                  form={settingsForm}
                  layout="vertical"
                  className="settings-form"
                  initialValues={DEFAULT_SETTINGS_VALUES}
                >
                  <Form.Item
                    name="approvalMode"
                    rules={[
                      {
                        required: true,
                        message: 'Please select how contractor invitations are handled.',
                      },
                    ]}
                  >
                    <Radio.Group className="settings-radio-group" disabled={settingsFetching} >
                      <Radio value="auto" style={{width: '100%', display: 'block'}}>
                        <span>Enable automatic contractor approval</span>
                        {approvalMode === 'auto' && (
                          <div className="settings-suboptions">
                            <Form.Item
                              name="automaticApprovalMode"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please choose how automatic approval is applied.',
                                },
                              ]}
                            >
                              <Radio.Group className="settings-radio-group" disabled={settingsFetching} style={{width: '100%'}}>
                                <Radio value="allEmails">Enable all emails</Radio>
                                <Radio value="listedDomains">Enable listed domains</Radio>
                                <Radio value="listedEmails">Enable listed emails</Radio>
                              </Radio.Group>
                            </Form.Item>
                            {automaticApprovalMode === 'listedDomains' && (
                              <Form.Item
                                name="domains"
                                style={{width: '100%'}}
                                label="Allowed domains"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter at least one domain.',
                                  },
                                ]}
                              >
                                <Input.TextArea
                                  rows={3}
                                  placeholder="Enter allowed domains, one per line. Ex: mail.airagri.tech"
                                  disabled={settingsFetching}
                                />
                              </Form.Item>
                            )}
                            {automaticApprovalMode === 'listedEmails' && (
                              <Form.Item
                                name="emails"
                                label="Allowed emails"
                                style={{width: '100%'}}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter at least one email.',
                                  },
                                ]}
                              >
                                <Input.TextArea
                                  rows={3}
                                  placeholder="Enter allowed emails, one per line. Ex: user-contractor@mail.airagri.tech"
                                  disabled={settingsFetching}
                                />
                              </Form.Item>
                            )}
                          </div>
                        )}
                      </Radio>
                      <Radio value="manual">Manual contractor approval</Radio>
                      <Radio value="reject">Reject contractor requests</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Form>
                <div className="settings-actions">
                  <Button
                    type="primary"
                    loading={settingsSubmitting}
                    disabled={settingsFetching}
                    onClick={handleSettingsSubmit}
                  >
                    Update contractor settings
                  </Button>
                </div>
              </>
            )}
          </div>
        </TabPane>
      </Tabs>
    </PropertyModalWrapper>
  );
}

export default UserAccessModal;
